import { storage } from '@uhg-abyss/web/tools/storage';

import { Constants } from '../Constants';
import { capitalizeFirstLetter } from '../Utils/capitalizeFirstLetter';

export const extractRollupCodesParts = (inputs: string[]): any[] =>
  inputs?.map((organization) =>
    capitalizeFirstLetter(organization?.toString().toLowerCase())
  );

export const hasKeyCARF = (keys: string): boolean => {
  const keyArray = keys.split(',').map((key) => key.trim());
  return keyArray.includes('CARF');
};

const PROVIDER_BIO_FEEDBACK =
  Constants.STORAGE_KEYS.SESSION.PROVIDER_BIO_FEEDBACK;

type ProviderBioFeedbackEntry = {
  thumbsUp: boolean;
};

type ProviderBioFeedbackMap = {
  [npi: string]: ProviderBioFeedbackEntry;
};

export function setProviderBioFeedback(npi: string, thumbsUp: boolean) {
  const data: ProviderBioFeedbackMap =
    storage.local.get(PROVIDER_BIO_FEEDBACK) || {};
  data[npi] = { thumbsUp };
  storage.local.set(PROVIDER_BIO_FEEDBACK, data);
}

export function getProviderBioFeedback(npi: string): boolean | undefined {
  const data: ProviderBioFeedbackMap =
    storage.local.get(PROVIDER_BIO_FEEDBACK) || {};
  return data[npi]?.thumbsUp;
}
